import React from 'react'
import InputAnt, { InputProps as InputPropsAnt } from 'antd/es/input/Input'

type SizeType = 'small' | 'middle' | 'large'

export interface InputProps extends Omit<InputPropsAnt, 'size'> {
  size?: keyof typeof SizeTypeParams
}

interface SizeTypeProps {
  sm: SizeType
  md: SizeType
  lg: SizeType
}

const SizeTypeParams: SizeTypeProps = {
  sm: 'small',
  md: 'middle',
  lg: 'large',
}

const selectSize = (size: keyof typeof SizeTypeParams): SizeType =>
  SizeTypeParams[size] ?? SizeTypeParams.md

export const Input: React.FC<InputProps> = ({
  value = '',
  size = 'md',
  ...props
}: InputProps): React.ReactElement => <InputAnt {...props} size={selectSize(size)} value={value} />
